(function () {
  function initNewSlideshows() {
    document.querySelectorAll('.new-slideshow').forEach(function (el) {
      if (el.dataset.nswInitialized) return;
      el.dataset.nswInitialized = 'true';

      var autoplay = el.dataset.autoplay === 'true';
      var delay = parseInt(el.dataset.delay, 10) || 5000;
      var speed = parseInt(el.dataset.speed, 10) || 800;

      var autoplayParams = autoplay
        ? {
            autoplay: {
              delay: delay,
              disableOnInteraction: false,
            },
          }
        : {};

      new Swiper(el, {
        speed: speed,
        rewind: true,
        keyboard: true,
        ...autoplayParams,
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initNewSlideshows);
  document.addEventListener('shopify:section:load', initNewSlideshows);
})();
